import { Tag } from "../../../../../../shared/frontend/ui";
import { LIFECYCLE_LEAD,LIFECYCLE_MEMBER,lifecycleLabel,lifecycleTagColor } from "./lifecycle";
import type { LifecycleStatus } from "./types";

export function lifecycleTag(
  status: LifecycleStatus,
  locked?: boolean,
  text: (key: string) => string = (x) => x,
  gender?: number | null
) {
  const s = (status || "").toString().trim();
  const color = lifecycleTagColor(s);
  const label = s ? lifecycleLabel(s, gender, text) : null;

  // Klasse für die Töne des Oberflächenstils (app/theme/styles/base.css „lifecycle-tag").
  const tone = s === LIFECYCLE_MEMBER ? "member" : s === LIFECYCLE_LEAD ? "lead" : "former";
  const base = label ? <Tag color={color} className={`lifecycle-tag lifecycle-tag--${tone}`}>{label}</Tag> : null;

  return (
    <span>
      {base}
      {locked ? <Tag color="red">{text("blocked")}</Tag> : null}
    </span>
  );
}
